import { z } from 'zod'

export const AssigneeSchema = z.object({
  id: z.number(),
  role: z.string(),
  status: z.string(),
  name: z.string(),
  email: z.string(),
  userId: z.number(),
  profilePicture: z.string().nullish(),
})

export type Assignee = z.infer<typeof AssigneeSchema>

export const TaskBaseSchema = z.object({
  id: z.number(),
  name: z.string(),
  detail: z.string().nullish(),
  priority: z.string().nullish(),
  teamId: z.number().nullish(),
  projectId: z.number().nullish(),
  assignees: z.array(AssigneeSchema).nullish(),
})

export type TaskLike = z.infer<typeof TaskBaseSchema>

export const BaseEditTaskSchema = z.object({
  name: z.string().min(1, { message: 'Task title is required.' }),
  detail: z.string().min(1, { message: 'Task note is required.' }).nullish(),
  priority: z.string().nullish(),
  assignees: z.array(z.number()).nullish(),
})
